export const ROLE_LABELS = {
  team_admin: 'Team Admin',
  head_coach: 'Head Coach',
  assistant_coach: 'Assistant Coach',
};

export function roleLabel(role) {
  return ROLE_LABELS[role] || role;
}

// Display order for role chips/lists — most senior first.
export const ROLE_ORDER = ['team_admin', 'head_coach', 'assistant_coach'];

export function sortRoles(roles) {
  return [...roles].sort((a, b) => ROLE_ORDER.indexOf(a) - ROLE_ORDER.indexOf(b));
}

// Guardian-facing "Coaching Staff" presentation (033-follow-up UI
// cleanup) — Team Admin is a real, unchanged backend permission role
// (see 009/team_staff), never removed or altered here; this only
// controls what a READ-ONLY, non-staff viewer (a connected guardian) is
// shown, so they don't mistake an administrative role for a coaching
// one. Staff/management viewers (Team Admin/Head Coach/Assistant Coach/
// Program authority) are never filtered — callers decide whether to use
// these based on the viewer's own authority, this module never guesses
// that itself.
export const COACHING_ROLES = ['head_coach', 'assistant_coach'];

/** For staffByPerson entries shaped { roles: [...roleStrings] }
 * (TeamDetailPage's Overview staff summary) — drops team_admin from
 * each person's displayed roles and omits anyone left with none (a
 * Team-Admin-only person). Someone holding Team Admin + a coaching role
 * still appears, showing only the coaching role. */
export function toCoachingStaffOnlyByRoles(staffByPerson) {
  return staffByPerson
    .map(p => ({ ...p, roles: p.roles.filter(r => COACHING_ROLES.includes(r)) }))
    .filter(p => p.roles.length > 0);
}

/** For staffByPerson entries shaped { rows: [...team_staff rows] }
 * (TeamStaffPage's directory, which needs the full row per chip for its
 * own — staff-viewer-only — remove affordance). Same filtering, applied
 * to row.role instead of a bare role string. */
export function toCoachingStaffOnlyByRows(staffByPerson) {
  return staffByPerson
    .map(p => ({ ...p, rows: p.rows.filter(r => COACHING_ROLES.includes(r.role)) }))
    .filter(p => p.rows.length > 0);
}
